const init = () => {
  const hash = location.hash;

  if (hash) {
    const target = document.querySelector(hash);
    const targetRect = target.getBoundingClientRect();
    const targetPos = targetRect.top + window.scrollY;
    const headerHeight = document.querySelector('#header').clientHeight;

    window.scrollTo(0, targetPos - headerHeight);
  }
};

export default init;
